import { useEffect, useState } from 'react'
import HeaderAppExplore from '../../sections/header/HeaderAppExplore'
import { userStateData } from '../../data/userStateData'
import { PAGE_URLS } from '../../constants/hrefLinks'

import './style.scss';
import { useAppDispatch } from '../../redux/hooks';
import { setShowNewPost } from '../../redux/reducers/userSlice';

function AppPostButton() {

	const dispatch = useAppDispatch()

	return (
		<button 
			className='app-button-post'
			onClick={() => {
				dispatch(setShowNewPost(true))
			}}
		>
			+ Post
		</button>
	)
}

export default AppPostButton
